export const FREQUENCY_VALUES = {
  NONE: 0,
  HALF_MONTH: 0.5,
  ONE_MONTH: 1,
  TWO_MONTHS: 2,
  THREE_MONTHS: 3,
};

export const LEVELS = ['level1', 'level2', 'level3', 'level4', 'level5', 'level6', 'level7', 'level8'];

export const FEES_DATA_TEST_ATTR = {
  PREFIX: 'cd-community-fees',
  CARE_PREFIX: 'cd-community-care-fees',
  VALUE: '-value',
  HISTORY: '-history',
  TITLE: '-title',
  TYPE: '-type',
  NOTE: '-note',
};
